<template>
    <div class="w3-container w3-responsive">

      <!-- 加载状态 -->
      <div v-if="loading" class="w3-panel w3-green w3-display-container">
        <span class="w3-button w3-large w3-display-topright" @click="loading = false">×</span>
        <p>加载中...</p>
      </div>
  
      <!-- 错误提示 -->
      <div v-if="error" class="w3-panel w3-red">
        <p>{{ error }}</p>
      </div>
  
      <!-- 数据列表 -->
      <table class="w3-table w3-striped w3-bordered w3-border w3-hoverable w3-white">
        <thead>
        <tr class="w3-green">
          <th>用户名</th>
          <th>注册时间</th>
          <th>最后登录</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.RecordId" class="w3-padding">
          <td class="w3-text-grey">{{ item.UserName }}</td>
          <td class="w3-text-grey">{{ $filters.formatDate(item.RegDate) }}</td>
          <td class="w3-text-grey">{{ $filters.formatDate(item.LastLogin) }}</td>
          <td class="w3-text-grey">
            <button class="w3-button w3-green w3-small" @click="$router.push(`/transferOut?o=${item.UserName}`)">转出</button>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="w3-text-grey w3-center">共 {{ list.length }} 个用户</td>
        </tr>
      </tbody>
      </table>
    </div>
  </template>
  
  <script>
 import axios from 'axios';

export default {
  data() {
    return {
      list: [],
      loading: false,
      error: '',
      agentName: '',
      agentPass: ''
    };
  },
  created() {

    const query = this.$route.query;

    if(query.u && query.p) {
      sessionStorage.setItem('agentName', query.u);
      sessionStorage.setItem('agentPass', query.p);
    }
    this.agentName = sessionStorage.getItem('agentName');
    this.agentPass = sessionStorage.getItem('agentPass');
    if(this.agentName && this.agentPass) {
      this.fetchData();
    } else {
      this.$router.push('/login');
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = '';
      try {

        const response = await axios.get(`${this.$apiUrl}/getUserList?agentname=${this.agentName}&t=${this.agentPass}`);
        if(response.data.code !== 200) {
          this.error = response.data.msg;
          this.$router.push('/login?err=1');
          return;
        } 
        this.list = response.data.result;
      } catch (err) {
        this.error = '获取数据失败，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
  </script>
  
  <style scoped>
  /* 可选：添加自定义样式覆盖或补充 W3.CSS */
  .w3-container {
    margin: 0px auto;
    padding: 0px;
  }
  
  .w3-ul li {
    transition: background-color 0.3s;
  }
  .w3-ul li:hover {
    background-color: #f0f0f0;
  }
  </style>